import { AxiosInstance } from 'axios';
import { IProfile } from 'src/views/Admin/Profiles/types';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (
  profile: IProfile
) => {
  const response = await api.post(url, profile);
  return toResponse(response.data) as IProfile;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/profiles/add.ts